import {Response} from "../entities/Response";
import apiClient from "./http";
import {DeployTemplate} from "../entities/DeployTemplate";
import {DEPLOY_ENV} from "../utils/config";

export class DeployTemplateService {

    static async createTemplate(template: DeployTemplate) : Promise<Response<any>> {
        return await apiClient.post('/service/deploy/template/create', template);
    }

    static async updateTemplate(template: DeployTemplate) : Promise<Response<any>> {
        return await apiClient.post('/service/deploy/template/update', template);
    }

    static async getTemplate(request: { appKey: string, env: string }) : Promise<Response<DeployTemplate | null>> {
        return await apiClient.post('/service/deploy/template/get', request);
    }

}